import { away } from './away';
import { tenDLCBanner } from './tenDLCBanner';
import { mutationRequestConfig } from './mutationConfig';
import { GET_API_MICROSERVICE } from '../../config';

export const interceptorsRequestSuccess = (config) => {
    // delete config.headers['TimeZone'];
    // delete config.headers['X-Socket-Id'];
    // config.headers['TimeZone'] = moment.tz.guess();
    config.headers['External-Referer'] = window.location.href;
    config.headers['Salesmsg-App'] = window.location.href.includes('widget') ? 'widget' : 'vue';
    config.baseURL = GET_API_MICROSERVICE();

    const is_logger = config?.url?.includes('logger/v1/logs') && window.Config?.logger_base_url;

    if (is_logger) {
        config.baseURL = window.Config.logger_base_url;
    }

    away();
    tenDLCBanner();

    // Do something before request is sent
    return mutationRequestConfig(config);
};

export const interceptorsRequestError = (error) => {
    // Do something with request error
    return Promise.reject(error);
};
